import React, { useState } from 'react';
import SectionHeader from '@/components/SectionHeader';
import { Box } from '@legion-ui/core';
import UserInfo from '../UserInfo';
import { UsersType } from '@/@types/user.types';
import { ModalType } from '@/store/modal';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { FaEye, FaEyeSlash } from 'react-icons/fa';


interface UserInfoProps {
  user?: UsersType;
  toggleModal: (type: ModalType) => void;
  isLoading?: boolean;

}

const UserInfoSection: React.FC<UserInfoProps> = ({ user, isLoading = false }) => {
  const [showMasked, setShowMasked] = useState(true);
  console.log('user', user); // <-- Tambahkan baris ini

  const maskText = (text: string, visibleChars: number = 4) => {
    if (!text || !showMasked) return text;
    
    // Untuk text yang sangat pendek, tetap mask minimal 2 karakter pertama
    if (text.length <= 3) {
      return '*'.repeat(text.length - 1) + text.slice(-1);
    }
    
    // Untuk text pendek (4-6 karakter), tampilkan maksimal 50% karakter terakhir
    if (text.length <= visibleChars + 2) {
      const charsToShow = Math.max(1, Math.floor(text.length / 2));
      const maskedLength = text.length - charsToShow;
      const masked = '*'.repeat(maskedLength);
      return masked + text.slice(-charsToShow);
    }
    
    // Untuk text panjang, gunakan visibleChars
    const maskedLength = text.length - visibleChars;
    const masked = '*'.repeat(Math.min(maskedLength, 10)); // Maximum 10 asterisks
    return masked + text.slice(-visibleChars);
  };

  const toggleMasking = () => {
    setShowMasked(!showMasked);
  };
  // Skeleton loading state
   if (isLoading) {
    return (
      <Box mb="1.5rem">
        <Skeleton height={24} width={150} className="mb-4" />
        <div className="flex flex-col w-full gap-8 sm:flex-row sm:items-center">
          <div className="flex justify-center sm:justify-start">
            {/* Avatar Skeleton */}
            <div className="w-32 h-32">
              <Skeleton height={128} width={128} borderRadius="50%" />
            </div>
          </div>
          <div className="flex flex-col w-full gap-3 mt-1 sm:mt-0">
            {/* User Info Skeleton */}
            {[...Array(7)].map((_, i) => (
              <div key={i} className="flex gap-2">
                <Skeleton height={20} width={100} />
                <Skeleton height={20} width={200} />
              </div>
            ))}
          </div>
        </div>
      </Box>
    );
  }

  return (
    <Box mb="1.5rem">
      <div className="flex items-center justify-between mb-4">
        <SectionHeader title="User Information" />
        <button
          onClick={toggleMasking}
          className="flex items-center gap-2 px-3 py-2 text-sm text-blue-600 border border-blue-600 rounded-lg hover:bg-blue-50 transition-colors"
        >
          {showMasked ? <FaEye /> : <FaEyeSlash />}
          {showMasked ? 'Show Data' : 'Hide Data'}
        </button>
      </div>
      <div className="flex flex-col w-full gap-8 sm:flex-row sm:items-center">
        <div className="flex justify-center sm:justify-start">
          {/* Avatar */}
          <div className="w-32 h-32">
            <img
              src={
                user?.info?.avatar ||
                '/assets/avatar.png'
              }
              alt="user-avatar"
              crossOrigin="anonymous"
              className="object-cover w-full h-full rounded-full"
            />
          </div>
        </div>
        <div className="flex flex-col w-full gap-3 mt-1 sm:mt-0">
          {/* User Info */}
          <UserInfo label="Fullname:" value={maskText(user?.info?.fullname || '-', 4)} />
          <UserInfo label="Username:" value={maskText(user?.username || '-', 4)} />
          <UserInfo label="Email:" value={maskText(user?.email || '-', 6)} />
          <UserInfo
            label="No Handphone:"
            value={maskText(user?.info?.phone_number || '-', 4)}
          />
          <UserInfo label="Gender:" value={user?.info?.gender || '-'} />
          <UserInfo label="Country:" value={user?.info?.country || '-'} />
          <UserInfo label="Street Address:" value={maskText(user?.info?.address || '-', 8)} />
        </div>
      </div>
    </Box>
  );
};

export default UserInfoSection;
